import axios from 'axios';

export const fetchFile = async (scenario, filename) => {
  try {
    const response = await axios.get(`https://flood-forecasting-preprod.alcom-gfxvd.com/api/${scenario}/${filename}`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du fichier:', error);
  }
};
